import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostContentOffersSucceed, EGetPostContentOffersActionType } from './types';
import { IPostContentRecommendedOffers } from '../../../types/postContentRecommendedOffers';

export const getPostContentOffersSucceed: (data: IPostContentRecommendedOffers) => TGetPostContentOffersSucceed =
  actionGenerator<EGetPostContentOffersActionType.Succeed, IPostContentRecommendedOffers>(
    EGetPostContentOffersActionType.Succeed,
  );
